import React from 'react'
import _ from 'lodash/fp'

import { getClubLogo, getClubImage } from '../../config'
import GenericMap, { GenerateUserPositionMarker, GlfrInfoWindow } from '../../components/Map'
import { markerDecorator } from '../../images'

// Map things
import {
  Marker
} from 'react-google-maps'
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer'

class ClubInfoWindow extends React.Component {
  render () {
    const { activeMarkerId, showingInfoBox, club, onCloseClick } = this.props
    const id = _.get('id', club)
    const galleryImage = _.flow(
      _.get('gallery_file_names'),
      _.first
    )(club)
    const { customer, teaser, name } = club
    return (
      <>
        <GlfrInfoWindow
          media={galleryImage && `url(${getClubImage(galleryImage)})`}
          visible={activeMarkerId === id && showingInfoBox}
          onCloseClick={onCloseClick}
          title={name}
          left={customer && teaser && <div dangerouslySetInnerHTML={{ __html: teaser }} />}
        />
      </>
    )
  }
}

export class ClubMarker extends React.Component {
  state = {
    image: undefined,
    markerHeight: undefined,
    markerWidth: undefined
  }

  createImage = (image, height, width) => {
    this.setState({
      image: image,
      markerHeight: height,
      markerWidth: width
    })
  }

  componentDidMount () {
    const { club } = this.props
    const id = _.get('id', club)
    const logo = getClubLogo(id)
    const customer = _.get('customer', club)
    const height = 40
    const width = 25

    markerDecorator(
      customer ? 'icons.mapMarkerGreen' : 'icons.mapMarkerGreenPale',
      logo,
      customer,
      width,
      height
    ).then((image) => {
      this.createImage(image, height, width)
    })
  }

  render () {
    const { club } = this.props
    const { image, markerWidth, markerHeight } = this.state
    if (!image || !club) {
      return false
    }
    const id = _.get('id', club)
    const name = _.get('name', club)
    const props = {
      title: name,
      position: {
        lat: _.get('position.latitude', club),
        lng: _.get('position.longitude', club)
      },
      onClick: () => this.props.onClick(id)
    }
    if (this.state.image) {
      props.icon = {
        url: this.state.image,
        scaledSize: { width: markerWidth, height: markerHeight }
      }
    }
    return (
      <Marker
        {...props}
      >
        {this.props.children}
      </Marker>
    )
  }
}

/*
  Feeds the map with ClubMarker Markers, also sets the cente of the map
*/
export class ClubsMap extends React.Component {
  state = {
    activeMarkerId: undefined,
    showingInfoBox: false
  }

  handleMarkerClicked = (id) => {
    this.setState({
      activeMarkerId: id,
      showingInfoBox: true
    })
  }

  handleMapClicked = () => {
    this.setState({
      showingInfoBox: false,
      activeMarkerId: undefined
    })
  }

  render () {
    const { classes, position } = this.props
    return (
      <GenericMap
        placeholder='Find clubs near...'
        onClick={this.handleMapClicked}
        containerElement={<div style={{ height: 'calc(100vh - 64px)', paddingTop: 80 }} />}
        className={classes.widthCalc}
        defaultZoom={_.get('latitude', position) ? 11 : 8}
        defaultCenter={{ lat: _.get('latitude', position) || 56.21, lng: _.get('longitude', position) || 11.24 }}
      >
        {position && GenerateUserPositionMarker(position)}
        <MarkerClusterer
          averageCenter
          enableRetinaIcons
          gridSize={30}
        >
          {_.map((club) => (
            <ClubMarker
              key={_.get('id', club)}
              club={club}
              onClick={(id) => {
                if (this.state.activeMarkerId === id) {
                  this.handleMapClicked()
                } else {
                  this.handleMarkerClicked(id)
                }
              }}
            >
              <ClubInfoWindow
                club={club}
                onCloseClick={this.handleMapClicked}
                activeMarkerId={this.state.activeMarkerId}
                showingInfoBox={this.state.showingInfoBox}
              />
            </ClubMarker>
          ), this.props.clubs)}
        </MarkerClusterer>
      </GenericMap>
    )
  }
}
